var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6242 1L16.0908 8.81458L18.0471 4.20417L26.6242 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33228 1L12.7698 8.88854L10.9094 4.20417L2.33228 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8375 19.1157L20.0354 23.4095L26.0312 25.0584L27.7448 19.2105L22.8375 19.1157Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22168 19.2105L2.9248 25.0584L8.92064 23.4095L6.12897 19.1157L1.22168 19.2105Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59271 11.8606L6.92188 14.3888L12.8656 14.6534L12.6646 8.25439L8.59271 11.8606Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3637 11.8604L16.2283 8.18018L16.0908 14.6531L22.0346 14.3885L20.3637 11.8604Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92065 23.4092L12.5061 21.6633L9.41753 19.2529L8.92065 23.4092Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 21.6633L20.0354 23.4092L19.5385 19.2529L16.45 21.6633Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0354 23.4089L16.45 21.6631L16.7354 24.0006L16.7041 24.9839L20.0354 23.4089Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92065 23.4089L12.2519 24.9839L12.2311 24.0006L12.5061 21.6631L8.92065 23.4089Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3155 17.7087L9.33325 16.8316L11.4374 15.8691L12.3155 17.7087Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 17.7087L17.5187 15.8691L19.6333 16.8316L16.6406 17.7087Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92082 23.4095L9.43852 19.1157L6.12915 19.2105L8.92082 23.4095Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5176 19.1157L20.0353 23.4095L22.8374 19.2105L19.5176 19.1157Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0346 14.3882L16.0908 14.6528L16.6408 17.708L17.5189 15.8684L19.6335 16.8309L22.0346 14.3882Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 16.8309L11.4375 15.8684L12.3156 17.708L12.8656 14.6528L6.92188 14.3882L9.33334 16.8309Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 14.3882L9.41771 19.2528L9.33334 16.8309L6.92188 14.3882Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6331 16.8309L19.5383 19.2528L22.0342 14.3882L19.6331 16.8309Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8654 14.6533L12.3154 17.7085L13.0133 21.3148L13.1613 16.5669L12.8654 14.6533Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0906 14.6533L15.8052 16.5564L15.9427 21.3148L16.6406 17.7085L16.0906 14.6533Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6408 17.7081L15.9429 21.3144L16.4502 21.6633L19.5387 19.2529L19.6335 16.8311L16.6408 17.7081Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 16.8311L9.41763 19.2529L12.5062 21.6633L13.0135 21.3144L12.3155 17.7081L9.33325 16.8311Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.704 24.9842L16.7352 24.0008L16.4717 23.7686H12.4842L12.2311 24.0008L12.2519 24.9842L8.92065 23.4092L10.0842 24.3602L12.4529 25.9998H16.5029L18.8717 24.3602L20.0352 23.4092L16.704 24.9842Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 21.6634L15.9427 21.3145H13.0135L12.5062 21.6634L12.2312 24.0009L12.4843 23.7686H16.4718L16.7354 24.0009L16.45 21.6634Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0677 9.32292L27.9562 5.00833L26.6239 1L16.45 8.55104L20.3635 11.8604L25.8937 13.4792L27.1104 12.051L26.5812 11.6708L27.427 10.8979L26.7822 10.3906L27.6281 9.74583L27.0677 9.32292Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.00833L1.89896 9.32292L1.32813 9.74583L2.17396 10.3906L1.52917 10.8979L2.375 11.6708L1.84583 12.051L3.0625 13.4792L8.59271 11.8604L12.5063 8.55104L2.33229 1L1 5.00833Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8935 13.4791L20.3633 11.8604L22.0342 14.3885L19.5383 19.2531L22.8373 19.2104H27.7446L25.8935 13.4791Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59251 11.8604L3.0623 13.4791L1.22168 19.2104H6.12897L9.41751 19.2531L6.92168 14.3885L8.59251 11.8604Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0904 14.6531L16.4498 8.55098L18.0467 4.2041H10.9092L12.5061 8.55098L12.8654 14.6531L13.0029 16.577L13.0133 21.3145H15.9425L15.9529 16.577L16.0904 14.6531Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.94d13c56575a303943f311294e3b32d5.svg";
export { ForwardRef as ReactComponent };